export default "__VITE_ASSET__D6ucm67p__"